import { Component, Input } from '@angular/core';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { ConfigService } from '@core/Abstract/config.service';

//
@Component({
    selector: 'app-loader',
    template: `
    <div *ngIf="animate" class="app-loader text-center"> 
        <img src="assets/images/loaders/{{_icon}}" alt="loading" class="icon-loader" />
    </div>
  `
})
export class LoaderComponent {
    //flag to show / hide loader
    animate: boolean = false;
    @Input('animate') set setAnimate(value: boolean) {
        this.selectVisibleIcon();
        this.animate = value;
    }
    //specific icon selection (optional, empty means random)
    _icon: string = null;
    icon: string = null;
    @Input('icon') set setIcon(value: string) {
        this.selectVisibleIcon();
        this.icon = value;
    }
    //array of icons to choose from
    // preset with svgs of [assets\images\loaders]
    svgList: Array<string> = [
        'bar-hor.svg',
        'bar-vert.svg',
        'donut-sized.svg',
        'donut.svg',
        'pie.svg'
    ];
    @Input('svgList') set setsvgList(value: Array<string>) {
        this.selectVisibleIcon();
        this.svgList = [...value];
    }

    constructor(protected securityService: SecurityService, 
        protected eventsEmitterService: EventsEmitterService,
        protected logger: LogService, 
        protected configService: ConfigService) {
    }

    selectVisibleIcon(){
        if(!this.icon && this.svgList){
            this._icon = this.svgList[Math.floor(Math.random()*this.svgList.length)]
        } else {
            this._icon = this.icon;
        }
    }

    ngOnInit(){ 
        this.selectVisibleIcon();
    }

}
